import { render, staticRenderFns } from "./vaidio.vue?vue&type=template&id=641d02aa&scoped=true"
import script from "./vaidio.vue?vue&type=script&lang=js"
export * from "./vaidio.vue?vue&type=script&lang=js"
import style0 from "./vaidio.vue?vue&type=style&index=0&id=641d02aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641d02aa",
  null
  
)

export default component.exports